import { Divider as Divider$1 } from '@magnetic/divider';
import { useClassNames } from '@magnetic/hooks';
import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const Divider = /* @__PURE__ */ __name(({
  className,
  ...rest
}) => {
  const classNames = useClassNames("mds-popover-rebuild-divider", className);
  return /* @__PURE__ */ React.createElement(Divider$1, {
    ...rest,
    className: classNames
  });
}, "Divider");

export { Divider };
//# sourceMappingURL=divider.js.map
